import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import { store } from '@/plugins/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/layouts/LayoutMain.vue'),
    children: [
      {
        path: '/',
        name: 'Main',
        props: true,
        meta: {
          title: '방송대 기출문제 OMR'
        },
        component: () => import('../views/biz/main/Main.vue'), 
      },
      {
        path: '/notice/notices',
        name: 'Notification',
        props: true,
        meta: {
          title: '공지사항'
        },
        component: () => import('../views/biz/notice/Notification.vue'), 
      },
      {
        path: '/notice/school',
        name: 'SchoolNotice',
        props: true,
        meta: { 
          title: '학교주요소식'
        },
        component: () => import('../views/biz/notice/SchoolNotice.vue'), 
      },
      {
        path: '/mypage',
        name: 'Mypage',
        props: true,
        meta: { 
          auth: true,
          title: '마이페이지'
        },
        component: () => import('../views/biz/mypage/Mypage.vue'), 
      },
      {
        path: '/board/boards/:tabCode?',
        name: 'Board',
        props: true,
        meta: { 
          title: '정보공유'
        },
        component: () => import('../views/biz/board/Board.vue'), 
      },
      {
        path: '/omr',
        name: 'OmrMain',
        props: true,
        meta: {
          // auth: true,
          title: '기출문제 자동채점 OMR'
        },
        component: () => import('../views/biz/omr/OmrMain.vue'), 
      },
      {
        path: '/omr/search',
        name: 'OmrSearch',
        props: true,
        meta: { 
          // auth: true,
          title: '기출문제 검색'
        },
        component: () => import('../views/biz/omr/OmrSearch.vue'), 
      },
      {
        path: '/omr/learn/:emNo',
        name: 'OmrLearn',
        props: true,
        meta: { 
          auth: true,
          title: '',  // 기출문제 풀기
          complete: false
        },
        component: () => import('../views/biz/omr/OmrLearnV2.vue'), 
      },
      {
        path: '/wrong-answer-note/wrong-answer-notes',
        name: 'WrongAnswerNoteMain',
        props: true,
        meta: { 
          auth: true,
          title: '오답노트'
        },
        component: () => import('../views/biz/note/WrongAnswerNoteMain.vue'), 
      },
      {
        path: '/wrong-answer-note/:emExam/:smNo',
        name: 'WrongAnswerNotes',
        props: true,
        meta: { 
          auth: true,
          title: '오답노트 목록'
        },
        component: () => import('../views/biz/note/WrongAnswerNotes.vue'), 
      },
      {
        path: '/wrong-answer-note/:emNo',
        name: 'WrongAnswerNoteDetail',
        props: true,
        meta: { 
          auth: true,
          title: '' // 오답노트 상세
        },
        component: () => import('../views/biz/note/WrongAnswerNoteDetail.vue'), 
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/biz/login/Login.vue')
  },
  {
    path: '/board/form',
    name: 'BoardForm',
    props: true,
    meta: { 
      auth: true,
      title: '글쓰기'
    },
    component: () => import('../views/biz/board/BoardForm.vue'), 
  },
  {
    path: '/board/:bmNo',
    name: 'BoardDetail',
    props: true,
    component: () => import('../views/biz/board/BoardDetail.vue'),
  },
  {
    path: '/omr/report-history',
    name: 'ReportHistory',
    meta: { 
      auth: true,
      title: '답안지 제출 이력'
    },
    props: true,
    component: () => import('../views/biz/omr/OmrReportHistory.vue'),
  },
  {
    path: '/403',
    name: 'ForbiddenError',
    meta: { 
      title: '접근 제한'
    },
    component: () => import('../views/biz/error/ForbiddenError.vue'), 
  },


  /* 관리자 */
  {
    path: '/admin/notice/schools',
    name: 'AdminSchoolNotices',
    props: true,
    meta: { 
      adminRole: true,
      auth: true,
      title: '학교주요소식 관리'
    },
    component: () => import('../views/biz/admin/SchoolNoticeManagement.vue'), 
  },
  {
    path: '/admin/notice/school/form/:snNo?',
    name: 'AdminSchoolNoticeForm',
    props: true,
    meta: { 
      adminRole: true,
      auth: true,
      title: '학교주요소식 등록'
    },
    component: () => import('../views/biz/admin/SchoolNoticeManagementForm.vue'), 
  },
  {
    path: '/admin/slide/slides',
    name: 'AdminSlideManagement',
    props: true,
    meta: { 
      adminRole: true,
      auth: true,
      title: '슬라이드 관리'
    },
    component: () => import('../views/biz/admin/slide/SlideManagement.vue'), 
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) { // 링크 이동 시 스크롤 top으로
    return new Promise((resolve) => {
      if (to.hash) {
        resolve({ selector: to.hash });
      } else if (savedPosition) {
        resolve(savedPosition);
      } else {
        resolve({ x: 0, y: 0 });
      }
    })
  }
});

router.beforeEach((to, from, next) => {
  // 모달이 열려있다면
  if(store.state.openedModals.length) {
    store.dispatch('popLastModal');
    return;
  }
  
  if(from.name == 'OmrLearn') {
    // 기출문제를 아직 풀고 있다면
    if(store.state.isOmrLearn) {
      if(confirm('채점이 완료되지 않았습니다.\n채점을 완료하지 않고 뒤로 가실 경우 시스템의 일부 기능을 사용할 수 없어요.\n뒤로 가시겠습니까?')) {
        store.dispatch('changeOmrLearn', false);
        next();
        return;
      }
      
      next(false)
      return;
    }
  }

  if(!to.meta.auth) { // 인증 no필요
    next();
    return;
  }
  
  axios.get('/login/ping')
  .then(r=>{
    console.log(r.data)
    if(r.data as string == 'admin') {
      next();
      return;
    }
    
    if(!to.meta.adminRole && r.data as string == 'member') {
      next();
      return;
    }

    // 접근 권한이 없습니다 페이지로 이동
    if(to.meta.adminRole) {
      next({name: 'ForbiddenError'});
      return;
    }

    const params = to.params;
    params.toName = to.name || 'Main';
    next({name: 'Login', params: params});
  });
  
});


export default router